import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumb.css';

function Breadcrumb({ pageName, bgImage, path }) {
  const validPath = path ? path.filter(item => item && item.label && item.label.trim() !== '') : [];

  return (
    <section
      className="breadcrumb-banner"
      style={
        bgImage
          ? {
              backgroundImage: `url(${process.env.PUBLIC_URL + bgImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }
          : {}
      }
    >
      <div className="overlay"></div>
      <div className="wrap position-relative">
        <div className="crumbs">
          {validPath.map((item, index) => (
            <span key={index}>
              {item.href ? (
                item.href.startsWith('http') || item.href.startsWith('#') ? (
                  <a href={item.href}>{item.label}</a>
                ) : (
                  <Link to={item.href}>{item.label}</Link>
                )
              ) : (
                <span>{item.label}</span>
              )}
              {index < validPath.length - 1 && <span className="sep">/</span>}
            </span>
          ))}
        </div>
        <h1>{pageName}</h1>
      </div>
    </section>
  );
}

export default Breadcrumb;

